/**
 * PublicShell — marketing + auth + /p/:slug layout. Sticky blurred
 * top-nav, full-bleed body, persistent footer. The body renders via
 * <Outlet /> so each public route stays free-form.
 *
 * Nav variants: when the visitor is already signed in (Convex Auth
 * has a live identity), the right-side CTAs swap from "Sign in /
 * Build my card" to "Go to dashboard". Doesn't load /auth/me — a
 * present identity is a good-enough proxy for "this is a known
 * visitor" on a public surface.
 */
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useConvexAuth } from 'convex/react';
import { PublicShellFrame } from './PublicShellFrame';

export function PublicShell() {
  // Reactive auth state. Don't paint the signed-in nav
  // until hydration confirms it.
  const { isAuthenticated } = useConvexAuth();
  return (
    <PublicShellFrame signedIn={isAuthenticated}>
      {/* Lazy routes (main.tsx) load here, under the nav. */}
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </PublicShellFrame>
  );
}
